module.exports = __webpack_public_path__ + "media/hero_1.bb8027c2.mp4";